import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Subject } from 'rxjs';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'nz-time-session-modal',
  templateUrl: './time-session-modal.component.html',
  styleUrls: ['./time-session-modal.component.scss']
})
export class NzTimeSessionModalComponent implements OnInit, OnDestroy {
  @Input() time: number;
  unsubscribe$ = new Subject();
  timerId: any;
  constructor(private modal: NzModalRef,
              private authService: AuthService) { }

  ngOnInit(): void {
    this.runTimer();
  }
  destroyModal(isHand = true, closeDefault = false): void {
    clearInterval(this.timerId);
    this.authService.logout();
    this.unsubscribe();
    this.modal.destroy({ data: false, isHand: isHand, closeDefault });
  }
  unsubscribe() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  submit() {
    clearInterval(this.timerId);
    this.authService.info().subscribe();
    this.unsubscribe();
    this.modal.destroy({ data: true });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  runTimer() {
    this.timerId = setInterval(() => {
      this.time -= 1;
      if (this.time === 0) {
        clearInterval(this.timerId);
        this.authService.logout();
      }
    }, 1000);
  }
}
